import { defineComponent } from 'vue';
import { CaretRightOutlined } from '@ant-design/icons-vue';
import { LoginService } from '@/services/login.service';
import { useService } from '@kaokei/use-vue-service';
import { useRouter } from 'vue-router';
export default defineComponent({
  name: 'GoToEnvCheckDialog',
  components: {
    CaretRightOutlined: CaretRightOutlined
  },
  setup: function () {
    var loginService = useService(LoginService);
    var router = useRouter();
    var goToEnvCheck = function () {
      loginService.hideGoToEnvCheckDialog();
      router.push({
        name: 'UserEnvCheck'
      });
    };
    return {
      loginService: loginService,
      goToEnvCheck: goToEnvCheck
    };
  }
});